import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { useDOMEventListener } from 'Src/feature/dom-event/useDOMEventListener';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';
import { useModalControl } from 'Src/feature/modal/useModalControl';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';

import styles from './RemoteClockoutModal.module.scss';

const RemoteClockoutModal: FC = () => {
  const { t } = useTranslation();
  const { employeeId } = useCurrentOperator();

  const modal = useModalControl({
    onOpen: () => setTimeout(() => window.location.reload(), 5000),
  });

  useDOMEventListener('notify.EntityCUD.EmployeeShift.Updated', useCallback((evt) => {
    if (!!evt.detail.entity.clockOut && evt.detail.entity.employeeId === employeeId) modal.open();
  }, [employeeId, modal]));

  return (
    <Modal
      open={modal.isOpen}
      variant="grow"
    >
      <ModalHeader>
        <ModalTitle copy={t('remoteClockout.labels.title')} />
      </ModalHeader>
      <ModalContent className={styles.content}>
        <Copy value={t('remoteClockout.labels.message')} />
      </ModalContent>
    </Modal>
  );
};

export { RemoteClockoutModal };
